import React from 'react';

function ContactModal({ show, onClose }) {
  if (!show) return null;

  return (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={onClose}>
      <div className="modal-dialog modal-lg" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content" style={{ borderRadius: '20px', border: 'none' }}>
          <div className="modal-header" style={{ border: 'none', padding: '40px 40px 20px', background: '#fff', position: 'relative' }}>
            <div style={{ width: '100%' }}>
              <h2 style={{ fontSize: '32px', fontWeight: '700', color: '#333', marginBottom: '15px' }}>Let's Plan Your Corporate Gifting!</h2>
              <p style={{ fontSize: '16px', color: '#666', margin: '0' }}>Prefer to speak to us directly? Call us at <span style={{ color: '#dc3545', fontWeight: '600' }}>+91 9823666125</span> for immediate assistance.</p>
            </div>
            <button type="button" className="close" onClick={onClose} style={{ position: 'absolute', top: '20px', right: '20px', fontSize: '32px', opacity: '0.5' }}>&times;</button>
          </div>
          <div className="modal-body" style={{ padding: '20px 40px 40px' }}>
            <form name="contactform" className="contact-form" action="mail.php" method="POST">
              <div className="row">
                <div className="col-md-6" style={{ marginBottom: '20px' }}>
                  <label style={{ fontSize: '14px', fontWeight: '600', color: '#333', marginBottom: '8px', display: 'block' }}>Full Name *</label>
                  <input type="text" name="name" className="form-control" placeholder="Enter your full name" required style={{ height: '50px', borderRadius: '10px', border: '1px solid #ddd', padding: '0 15px', fontSize: '15px' }} />
                </div>
                <div className="col-md-6" style={{ marginBottom: '20px' }}>
                  <label style={{ fontSize: '14px', fontWeight: '600', color: '#333', marginBottom: '8px', display: 'block' }}>Work Email ID *</label>
                  <input type="email" name="email" className="form-control" placeholder="your.email@company.com" required style={{ height: '50px', borderRadius: '10px', border: '1px solid #ddd', padding: '0 15px', fontSize: '15px' }} />
                </div>
                <div className="col-md-6" style={{ marginBottom: '20px' }}>
                  <label style={{ fontSize: '14px', fontWeight: '600', color: '#333', marginBottom: '8px', display: 'block' }}>Company Name *</label>
                  <input type="text" name="company" className="form-control" placeholder="Your company name" required style={{ height: '50px', borderRadius: '10px', border: '1px solid #ddd', padding: '0 15px', fontSize: '15px' }} />
                </div>
                <div className="col-md-6" style={{ marginBottom: '20px' }}>
                  <label style={{ fontSize: '14px', fontWeight: '600', color: '#333', marginBottom: '8px', display: 'block' }}>Preferred Gifting Category *</label>
                  <select name="category" className="form-control" required style={{ height: '50px', borderRadius: '10px', border: '1px solid #ddd', padding: '0 15px', fontSize: '15px' }}>
                    <option value="">Select category</option>
                    <option value="Standard">Standard</option>
                    <option value="Premium">Premium</option>
                    <option value="Super-Premium">Super-Premium</option>
                  </select>
                </div>
                <div className="col-md-12" style={{ marginBottom: '20px' }}>
                  <label style={{ fontSize: '14px', fontWeight: '600', color: '#333', marginBottom: '8px', display: 'block' }}>Type of Requirement</label>
                  <input type="text" name="requirement" className="form-control" placeholder="Product type or name/code" style={{ height: '50px', borderRadius: '10px', border: '1px solid #ddd', padding: '0 15px', fontSize: '15px' }} />
                </div>
                <div className="col-md-12" style={{ marginBottom: '25px' }}>
                  <label style={{ fontSize: '14px', fontWeight: '600', color: '#333', marginBottom: '8px', display: 'block' }}>Estimated Quantity</label>
                  <input type="text" name="quantity" className="form-control" placeholder="Approximate quantity needed" style={{ height: '50px', borderRadius: '10px', border: '1px solid #ddd', padding: '0 15px', fontSize: '15px' }} />
                </div>
                <div className="col-md-12">
                  <button type="submit" className="btn btn-primary" style={{ width: '100%', height: '55px', borderRadius: '10px', fontSize: '16px', fontWeight: '600', background: '#9A1111', border: 'none', transition: 'all 0.3s ease' }}>Submit Request</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactModal;
